

exports.__esModule = true;
var BUYNOW_WA_TYPE = exports.BUYNOW_WA_TYPE = 'BuyNow';
var SHOPPINGCART_WA_TYPE = exports.SHOPPINGCART_WA_TYPE = 'ShoppingCart';
var EN_DEFAULTS = exports.EN_DEFAULTS = {
    'CH': 'en_US',
    'ID': 'en_US',
    'JP': 'en_US',
    'PT': 'en_US',
    'TH': 'en_GB'
};
var SHOPPINGCART_VARS = exports.SHOPPINGCART_VARS = {
    TOTAL_HANDLING_CHARGES: 'total_handling_charges',
    TOTAL_WEIGHT: 'total_weight',
    ADDRESS_OVERRIDE: 'address_override',
    URLS: 'urls',
    INVOICE_NUMBER: 'invoice_number',
    PROMPT_NOTE: 'prompt_note'
};
var XCLICK_VARS = exports.XCLICK_VARS = {
    BUSINESS_NAME: 'business_name',
    CMD: 'cmd',
    ADD: 'add',
    ADDRESS_OVERRIDE: 'address_override',
    VISITOR_ID: 'visitor_id',
    MERCHANT_EMAIL: 'merchant_email',
    MERCHANT_ID: 'merchant_id',
    SHIPPING: 'shipping',
    TAX: 'tax',
    HANDLING: 'handling',
    DISCOUNT: 'discount',
    CUSTOM: 'custom',
    NOTE_TO_SELLER_LABEL: 'note_to_seller_label',
    LOCALE_CODE: 'locale_code',
    RETURN_URL_LABEL: 'return_url_label',
    RETURN_METHOD: 'return_method',
    MRB_CODE: 'mrb_code',
    INVOICE: 'invoice',
    NO_NOTE: 'no_note'
};

var ADDRESS_VARS = exports.ADDRESS_VARS = {
    LINE1: 'line1',
    LINE2: 'line2',
    CITY: 'city',
    COUNTRY_CODE: 'country_code',
    POSTAL_CODE: 'postal_code',
    STATE: 'state'
};

var PAYER_VARS = exports.PAYER_VARS = {
    EMAIL: 'email',
    FIRST_NAME: 'first_name',
    LAST_NAME: 'last_name'
};

var PHONE_PARAMS = exports.PHONE_PARAMS = {
    NIGHT_PHONE_A: 'night_phone_a',
    NIGHT_PHONE_B: 'night_phone_b',
    NIGHT_PHONE_C: 'night_phone_c'
};

var PII_XCLICK_PARAMS = exports.PII_XCLICK_PARAMS = ['address1', 'address2', 'email', 'first_name', 'last_name', 'night_phone_a', 'night_phone_b', 'night_phone_c', 'merchant_email', 'business'];

var MASKED_LOG = exports.MASKED_LOG = 'Masked****';


//////////////////
// WEBPACK FOOTER
// ./js/lib/constants.js
// module id = ./js/lib/constants.js
// module chunks = 1